import { useEffect } from 'react';
import { useAuthModal } from "../../../providers/auth-modal.provider";
import { getSafeInternalReturnTo } from '../../../utils/join';

const LoginRoute = () => {
    const { openModal } = useAuthModal();

    useEffect(() => {
        let storedRedirect: string | null = null;
        try {
            storedRedirect = window.localStorage.getItem('redirectAfterLogin');
        } catch {
            // Sign in remains available when browser storage is blocked.
        }
        openModal(
            'sign_in',
            storedRedirect ? getSafeInternalReturnTo(storedRedirect) : undefined
        );
    }, [openModal]);

    return null;
};

export default LoginRoute;
